<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <br />
    <a @click="$parent.hidePlan()">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <!--<div class="content-title content-mb-14">
      14. Состав оборудования в проекте, планируемого к приобретению за счет
      средств займа
    </div>
    <EquipmentZaim></EquipmentZaim>-->

    <div class="content-title content-mb-14">
      1. Состав оборудования в проекте, планируемого к приобретению за счет
      средств займа
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        :distance="25"
        style="display: inline"
      >
        <a class="icon-help" />
        <template #popper>
          <div class="custom-popper-content">
            Для добавления списка оборудования необходимо указать отрасль
            промышленности
          </div>
        </template>
      </VDropdown>
    </div>
    <EquipmentMarkirovka></EquipmentMarkirovka>

    <div class="content-title content-mb-14">
      2. РИД, лицензии и патенты, приобретаемые за счёт средств займа
    </div>
    <EquipmentLicensesPatentsMarkirovka></EquipmentLicensesPatentsMarkirovka>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
import EquipmentZaim from "@/components/project/form/partial/EquipmentZaim";
import EquipmentLicensesPatentsMarkirovka from "@/components/project/form/partial/EquipmentLicensesPatentsMarkirovka";
import EquipmentMarkirovka from "@/components/project/form/partial/EquipmentMarkirovka";
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "step7lekarstva",
  components: {
    EquipmentMarkirovka,
    EquipmentLicensesPatentsMarkirovka,
    EquipmentZaim,
    UFDopInfo,
    VDropdown
  },
  props: ["step", "project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  mounted() {
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    }
  }
};
</script>

<style scoped></style>
